import { checkAPIResponse } from "../../../Utils/APIResponseUtils";
import apiService from "../../../Services/APIService";

export const getSubscriptionData = async () => {
    const payload = {
        changeType: "BZINVOICES"
    }

    try{
        const result = await apiService.getData(3, 'getConfig', payload)
        checkAPIResponse(result)
        // Parse the updatePackage to get the actual data
        const updatePackage = JSON.parse(result.updatePackage);
        const data = updatePackage ? updatePackage.Table1[0] : null;

        return data;
    }
    catch (error) {
        console.error('getConnectionDetail API error:', error);
        throw error;
    }
}

